import { ReactNode } from "react";
import { SurveyQuestion } from "@/components/common/resource-survey/components/survey-form/components/survey-question/survey-question";

export const SurveyStep = ({ step }: { step: SurveyStepVM }) => {
  const { rootIndex, nodes } = step;

  function renderNext(nodeIndex: number): ReactNode {
    const node = nodes[nodeIndex];
    return (
      <>
        <SurveyQuestion index={nodeIndex} node={node} />
        {!node.hasAnyConditionalTarget &&
          node.defaultTargetIndex &&
          renderNext(node.defaultTargetIndex)}
      </>
    );
  }

  function createRenderOrder(rootIndex: number): ReactNode {
    const root = nodes[rootIndex];
    return (
      <>
        <SurveyQuestion index={rootIndex} node={root} />
        {root.defaultTargetIndex &&
          renderNext(root.defaultTargetIndex as number)}
      </>
    );
  }

  const toRender = createRenderOrder(rootIndex);

  return <div>{toRender}</div>;
};
